const {h, render, Component} = require('preact');

class LiveChatAvailable extends Component {
  /*
    Kept the jquery code here for now.
  */
  constructor(props) {
    super(props);
    this.handleDisplayOfLiveChat = this.handleDisplayOfLiveChat.bind(this);
    let observer = new MutationObserver(mutationRecords => {
      for(let mutation of mutationRecords) {
        if(mutation.addedNodes && mutation.addedNodes.length > 0)
          for(let node of mutation.addedNodes)
            if(node.className === 'bcFloat') {
                this.handleDisplayOfLiveChat();
            }
      }
    });
    observer.observe(document.body, {
      childList: true, // observe direct children
    });
  }

  handleDisplayOfLiveChat(){
    let liveChatButton = $('#live-chat-container')
    let liveChatIcon = $('#live-chat-container span.channel-icon')
    let liveChatText = $('#live-chat-container span.channel-text')
    let liveChatRecommended = $('#live-chat-container span.recommended')
    let liveChatAvailableText = $('#live-chat-container span.chat-available')
    let liveChatUnavailableText = $('#live-chat-container span.chat-unavailable')
    let liveChatAvailabilityIndicator = $('.bcFloat div a img')

    if(this.isLiveChatVisible(liveChatAvailabilityIndicator))
    {
      liveChatUnavailableText.css('display','none')
      liveChatAvailableText.css('display','block')
      liveChatButton.removeClass('channel-unavailable')
      liveChatIcon.removeClass('channel-unavailable')
      liveChatText.removeClass('channel-unavailable')
      liveChatRecommended.removeClass('channel-unavailable')
    }
    else{
      liveChatAvailableText.css('display','none')
      liveChatUnavailableText.css('display','block')
      liveChatButton.addClass('channel-unavailable')
      liveChatIcon.addClass('channel-unavailable')
      liveChatText.addClass('channel-unavailable')
      liveChatRecommended.addClass('channel-unavailable')
    }
    var imgSelector = document.querySelectorAll(".bcFloat img")[0];
    if (imgSelector) {
      imgSelector.addEventListener('load', this.handleDisplayOfLiveChat)
    }
  }

  isLiveChatVisible(liveChatAvailabilityIndicator) {
    return !(liveChatAvailabilityIndicator[0] ? (liveChatAvailabilityIndicator[0].src.indexOf( "/images/clear.gif") >= 0) : true)
  }

  render() {
  }
}

module.exports = LiveChatAvailable
